export default __webpack_public_path__ + "static/media/bb.1f64d8e6.jpg";